module.exports = __webpack_public_path__ + "static/media/trillio_small.c696ad35.webp";